<template>
  <div class="product">
    <div class="hero">
      <div class="container">
        <div class="row">
          <div class="col-12 col-lg-12 col-xl-12">
            <h3>Wilt u ook de voordelen van geautomatiseerd plannen?</h3>
            <h1>Plan slim en lever meer zorg met dezelfde behandelaars</h1>
            <p>
              Roosterplatform plant uw behandelagenda volledig geautomatiseerd
              in slechts een paar minuten. U voert per cliënt de
              behandelvereisten en wensen in zoals aantal behandelingen per dag
              en rusttijden. Roosterplatform stelt daarmee een optimale
              behandelagenda voor u op.
            </p>
            <p>
              Zonder onnodige gaten en met ieder behandelmoment benut. Zo
              behandelt u cliënten beter en sneller waardoor ze eerder naar huis
              kunnen en u meer cliënten kunt behandelen met hetzelfde team. En
              wijzigt er iets? Bijvoorbeeld een cliënt die sneller herstelt en
              minder behandeling nodig heeft? Dan plant Roosterplatform meteen
              weer een optimale agenda.
            </p>
          </div>
          <div class="col-12 col-lg-12 col-xl-12 mockup-product">
            <svg
              id="blobSvg"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 500 500"
              width="100%"
              style="opacity: 1"
            >
              <defs>
                <linearGradient
                  id="gradient"
                  x1="0%"
                  y1="0%"
                  x2="0%"
                  y2="100%"
                >
                  <stop
                    offset="0%"
                    style="stop-color: #2571ca"
                  />
                  <stop
                    offset="100%"
                    style="stop-color: #80c9f8"
                  />
                </linearGradient>
              </defs>

              <path
                id="blob"
                fill="url(#gradient)"
                style="opacity: 1"
              >
                <animate
                  attributeName="d"
                  dur="30000ms"
                  repeatCount="indefinite"
                  values="M395.5,320Q390,390,320,400Q250,410,172,408Q94,406,59,328Q24,250,70.5,183.5Q117,117,183.5,108Q250,99,335,89.5Q420,80,410.5,165Q401,250,395.5,320Z;M409.06419,322.5266Q395.0532,395.0532,322.5266,445.11739Q250,495.18159,163.51944,459.07135Q77.03888,422.96112,82.39949,336.48056Q87.7601,250,115.64271,196.76266Q143.52532,143.52532,196.76266,76.83657Q250,10.14783,323.24578,56.82813Q396.49156,103.50844,409.78338,176.75422Q423.07519,250,409.06419,322.5266Z;M449.66467,329.57458Q409.14917,409.14917,329.57458,407.97733Q250,406.80549,191.3735,387.02924Q132.74701,367.25299,77.06026,308.6265Q21.3735,250,49.05191,163.36516Q76.73032,76.73032,163.36516,85.537Q250,94.34367,322.00775,100.16408Q394.01551,105.98449,442.09784,177.99225Q490.18018,250,449.66467,329.57458Z;M423.42552,332.41134Q414.82268,414.82268,332.41134,424.30554Q250,433.78841,170.96572,420.92848Q91.93144,408.06856,46.07152,329.03428Q0.21159,250,66.88003,191.77423Q133.54846,133.54846,191.77423,102.82861Q250,72.10876,305.00592,106.04846Q360.01185,139.98815,396.0201,194.99408Q432.02836,250,423.42552,332.41134Z;M405.0078,325.44624Q400.89248,400.89248,325.44624,434.97549Q250,469.0585,165.42535,444.1039Q80.8507,419.1493,84.75627,334.57465Q88.66184,250,94.44262,175.1117Q100.2234,100.2234,175.1117,82.29749Q250,64.37159,306.73538,100.45042Q363.47075,136.52925,386.29693,193.26462Q409.12312,250,405.0078,325.44624Z;M395.5,320Q390,390,320,400Q250,410,172,408Q94,406,59,328Q24,250,70.5,183.5Q117,117,183.5,108Q250,99,335,89.5Q420,80,410.5,165Q401,250,395.5,320Z"
                />
              </path>
            </svg>
            <img
              src="../assets/img/mockup-product.png"
              alt=""
            >
          </div>
        </div>
      </div>
    </div>

    <div class="section primary">
      <div class="container">
        <div class="section-title">
          <span>Deze onderdelen plant Roosterplatform voor u</span>
          <h2>Wat plannen we?</h2>
        </div>
        <p>
          In de behandelprogramma's en -kaarten legt u de behandeling van een
          cliënt vast. Bijvoorbeeld hoe vaak fysio en ergo per dag met welke
          duur en met welke rustpauzes tussen behandelingen. Daarmee plant
          Roosterplatform geautomatiseerd uw behandelagenda. Behandelaars werken
          dan optimaal en helpen zoveel mogelijk cliënten. En cliënten weten
          precies hun afspraken en daardoor wanneer familie of vrienden op
          bezoek kunnen komen.
        </p>
        <div class="row planning-items-holder">
          <div class="col-6 col-md-3 planning-item">
            <div class="image-holder">
              <img
                src="../assets/img/planning-items/planning-item-1.svg"
                alt=""
              >
            </div>
            <div class="big">
              Behandelprogramma’s
            </div>
            <div class="small opacity">
              Dagelijks of wekelijks
            </div>
          </div>
          <div class="col-6 col-md-3 planning-item">
            <div class="image-holder">
              <img
                src="../assets/img/planning-items/planning-item-2.svg"
                alt=""
              >
            </div>
            <div class="big">
              Behandelagenda
            </div>
            <div class="small opacity">
              Van behandelaren en cliënten
            </div>
          </div>
          <div class="col-6 col-md-3 planning-item">
            <div class="image-holder">
              <img
                src="../assets/img/planning-items/planning-item-3.svg"
                alt=""
              >
            </div>
            <div class="big">
              Behandelkaarten
            </div>
            <div class="small opacity">
              De vereisten en wensen per cliënt
            </div>
          </div>
          <div class="col-6 col-md-3 planning-item">
            <div class="image-holder">
              <img
                src="../assets/img/planning-items/planning-item-4.svg"
                alt=""
              >
            </div>
            <div class="big">
              Afspraken
            </div>
            <div class="small opacity">
              Inzichtelijk en optimaal
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="section grey-light">
      <div class="container">
        <div class="section-title">
          <span>Volledig geautomatiseerd</span>
          <h2>Hoe doet Roosterplatform dat?</h2>
        </div>
        <p>
          Roosterplatform leest vanuit uw ECD de basisgegevens en het
          behandelplan van cliënten in en u vult dat aan met de roosterstrategie
          in de vorm van vereisten en wensen. Bijvoorbeeld twee keer een half
          uur fysio en één keer een half uur ergo per dag met tussenliggende
          pauzes van minimaal twee uur. Verder legt u in Roosterplatform de
          specialismen en beschikbaarheid van uw behandelaars vast. Bijvoorbeeld
          iedere woensdagmiddag afblokken voor teamoverleg en geen behandelingen
          meer na 16:30 uur op dinsdag en donderdag.
        </p>

        <div class="roosterplatform-process">
          <img
            class="roosterplatform-process-background"
            src="../assets/img/roosterplatform-process.png"
            alt=""
          >
          <img
            class="roosterplatform-process-left"
            src="../assets/img/roosterplatform-process-left.png"
            alt=""
          >
          <img
            class="roosterplatform-process-right"
            src="../assets/img/roosterplatform-process-right.png"
            alt=""
          >
          <img
            class="roosterplatform-process-center"
            src="../assets/img/roosterplatform-process-center.png"
            alt=""
          >
        </div>

        <p>
          Met deze gegevens plant u met Roosterplatform geautomatiseerd een
          optimale behandelagenda in de volgende stappen:
        </p>
        <div class="steps">
          <div class="step-title">
            <b>1</b>
            <span class="sub-title">Leg de roosterstrategie vast</span>
          </div>
        </div>
        <div class="steps">
          <div class="step-title">
            <b>2</b>
            <span
              class="sub-title"
            >Plan geautomatiseerd de behandelagenda</span>
          </div>
        </div>
        <div class="steps">
          <div class="step-title">
            <b>3</b>
            <span class="sub-title">Beoordeel de behandelagenda</span>
          </div>
        </div>
        <div class="steps">
          <div class="step-title">
            <b>4</b>
            <span
              class="sub-title"
            >Los knelpunten op en voeg uitzonderingen toe</span>
          </div>
        </div>
        <div class="steps">
          <div class="step-title">
            <b>5</b>
            <span class="sub-title">Perfectioneer de behandelagenda</span>
          </div>
        </div>
        <div class="steps">
          <div class="step-title">
            <b>6</b>
            <span
              class="sub-title"
            >Verstuur de behandelgegevens naar EPD/ECD</span>
          </div>
        </div>
      </div>
    </div>
    <div class="section primary extra-padding-bottom">
      <div class="container">
        <div class="section-title">
          <span>De voordelen van Rooterplatform</span>
          <h2>Wat levert het u op?</h2>
          <p>
            Met Roosterplatform plant u uw behandelagenda volledig
            geautomatiseerd. Uw behandelaars werken optimaal met meer
            werkplezier en helpen meer cliënten. Uw cliënten weten precies waar
            ze aan toe zijn en worden optimaal behandelt waardoor ze sneller
            naar huis kunnen en weer zelfstandig zijn. En uw planners richten
            zich alleen nog op uitzonderingen en perfectioneren.
          </p>

          <div class="befinits-block">
            <div class="icon">
              <img
                src="../assets/img/check.png"
                alt=""
              >
            </div>
            <div>
              <p class="sub-title">
                U biedt optimale behandelprogramma’s voor uw cliënten op basis
                van:
              </p>
              <ul>
                <li>
                  Individuelen behandelingen en groepen met één of meerdere
                  behandelaren
                </li>
                <li>De wensen en eisen van de cliënt</li>
                <li>Diverse ritmes en frequenties</li>
              </ul>
            </div>
          </div>

          <div class="befinits-block">
            <div class="icon">
              <img
                src="../assets/img/check.png"
                alt=""
              >
            </div>
            <div>
              <p class="sub-title">
                U plant optimale agenda’s voor uw behandelaars op basis van:
              </p>
              <ul>
                <li>Beschikbaarheid</li>
                <li>Specialisatie</li>
                <li>Behandelrelatie</li>
                <li>De door u bepaalde productiviteitsnormen</li>
              </ul>
            </div>
          </div>

          <div class="befinits-block">
            <div class="icon">
              <img
                src="../assets/img/check.png"
                alt=""
              >
            </div>
            <div>
              <p class="sub-title">
                U stuurt uw resultaat vanuit dbc’s op basis van:
              </p>
              <ul>
                <li>Toegestane tarieven</li>
                <li>Kostprijzen</li>
              </ul>
            </div>
          </div>

          <div class="befinits-block">
            <div class="icon">
              <img
                src="../assets/img/check.png"
                alt=""
              >
            </div>
            <div>
              <p class="sub-title">
                U stuurt uw capaciteit op niveau van
              </p>
              <p>
                Op basis van de voorgeschreven behandelprogramma’s en de
                beschikbaarheid van de behandelaren wordt inzage gegeven in de
                benodigde capaciteit, op niveau van:
              </p>
              <ul>
                <li>Discipline</li>
                <li>Specialisatie</li>
                <li>Organisatiecluster</li>
              </ul>
            </div>
          </div>

          <div class="befinits-block">
            <div class="icon">
              <img
                src="../assets/img/check.png"
                alt=""
              >
            </div>
            <div>
              <p class="sub-title">
                U heeft inzicht in de wachtlijst via rapporten met:
              </p>
              <p>
                Ontsluiten data t.b.v. onderzoek welke zorgpaden gemiddeld
                worden geleverd per diagnosegroep
              </p>
              <p>
                Diverse rapporten worden opgeleverd om inzicht te krijgen in:
              </p>
              <ul>
                <li>Geplande versus geleverde behandelingen</li>
                <li>Gepland versus voorgeschreven behandelprogramma</li>
                <li>Hoeveel beschikbaarheid/inplanbaarheid</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Product",

  mounted() {},
  methods: {},
  metaInfo() {
    return {
      title: "Roosterplatform - Product",
    };
  },
};
</script>

<style scoped lang="scss">
@import "../assets/css/colors.scss";
@import "../assets/css/variables.scss";

.hero {
  padding: 150px 0 100px;
  position: relative;
  z-index: 1;
  p {
    font-size: $big;
  }
  h3 {
    opacity: 0.3;
    font-weight: 700;
  }

  .mockup-product {
    text-align: center;
    img {
      max-width: 1000px;
      margin: 100px auto 0;
      position: relative;
    }
    svg {
      position: absolute;
      top: 0;
      right: 0;
      width: 800px;
    }
  }
}

.roosterplatform-process {
  position: relative;

  .roosterplatform-process-background {
    animation: float 5s ease-in-out infinite;
    position: relative;
  }
  .roosterplatform-process-left {
    position: absolute;
    top: 0;
    left: 100px;
    bottom: 0;
    margin: auto 0;
  }
  .roosterplatform-process-right {
    position: absolute;
    top: 0;
    right: 160px;
    bottom: 0;
    margin: auto 0;
  }
  .roosterplatform-process-center {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 100px;
    margin: 0 auto;
  }
}

.dashboard-animation {
  position: relative;
  z-index: 0;
  margin: -100px 0;
}

.planning-items-holder {
  .planning-item {
    text-align: center;
  }
  .image-holder {
    background: $white;
    margin: 0 0 20px;
    padding: 10px;
    border-radius: $border-radius;
    min-height: 175px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.steps {
  padding-left: 50px;
  position: relative;

  .step-title {
    background: rgba($color: #04264e, $alpha: 0.05);
    padding: 10px 20px 10px 10px;
    display: inline-flex;
    border-radius: 40px;
    align-items: center;
    margin: 0 0 20px -50px;

    &:before {
      content: "";
      position: absolute;
      display: block;
      top: 80px;
      bottom: 0;
      left: 25px;
      width: 1px;
      color: rgba($color: $primary, $alpha: 0.1);
      border-left: 2px dashed;
    }

    b {
      font-size: 16px;
      border-radius: 100px;
      height: 24px;
      width: 24px;
      background: rgba($color: #04264e, $alpha: 0.3);
      color: $white;
      display: inline-block;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 10px;
    }
    .sub-title {
      margin: 0;
      color: rgba($color: #04264e, $alpha: 1);
      font-size: 16px;
      font-family: inherit;
    }
  }
}

.befinits-block {
  margin: 0 0 24px;
  background: $white;
  color: $text;
  padding: 24px;
  border-radius: $border-radius;
  position: relative;
  display: flex;

  .icon {
    img {
      max-width: 100px;
      margin-right: 20px;
    }
  }
}
@media (max-width: 991px) {
  .roosterplatform-process {
    display: flex;
    flex-direction: column;

    .roosterplatform-process-background {
      animation: none;
      transform: rotate(90deg);
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      margin: auto;
    }
    .roosterplatform-process-left,
    .roosterplatform-process-right,
    .roosterplatform-process-center {
      position: relative;
      top: auto;
      left: auto;
      bottom: auto;
      right: auto;
      margin: 0 auto;
      max-width: 40%;
    }
  }
}

@media (max-width: 767px) {
  .hero {
    padding-top: $header-height-small;

    .mockup-product {
      text-align: center;
      img {
        max-width: 100%;
        margin: 100px auto 0;
        position: relative;
      }
      svg {
        position: absolute;
        top: 0;
        right: 0;
        width: 300px;
      }
    }
  }

  .planning-items-holder {
    .planning-item {
      text-align: left;
      .image-holder {
        padding: 15px;
        min-height: 0;
        margin-bottom: 10px;

        img {
          width: 50%;
        }
      }
    }
  }
  .planning-item {
    margin-bottom: 20px;
    .big {
      font-size: 15px;
    }
  }

  .steps {
    &:last-child:before {
      width: 47px;
      height: 174px;
      left: -13px;
      bottom: -60px;
      background-size: 40px;
    }
    .sub-title {
      font-size: 14px;
    }
    .step-title {
      b {
        font-size: 14px;
        width: 20px;
        height: 20px;
      }
    }
  }

  .befinits-block {
    display: block;
    .icon {
      margin: auto;
      display: block;
      text-align: center;
      margin-bottom: 50px;
    }
  }
}

@keyframes float {
  0% {
    transform: translatey(0px);
  }
  50% {
    transform: translatey(-5px);
  }
  100% {
    transform: translatey(0px);
  }
}
</style>
